export default "__VITE_ASSET__Bjkv8nOD__"